module.exports = __webpack_public_path__ + "img/caigong.ecb3b6c7.svg";